import WebOperationListModelBase from '../_generated/modelBases/web-operation-list-model-base';

export default class WebOperationListModel extends WebOperationListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
